"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.twoHopSwapWithFeeDiscountIx = void 0;
const spl_token_1 = require("@solana/spl-token");
function twoHopSwapWithFeeDiscountIx(program, params) {
    const { amount, otherAmountThreshold, amountSpecifiedIsInput, aToBOne, aToBTwo, sqrtPriceLimitOne, sqrtPriceLimitTwo, whirlpoolOne, whirlpoolTwo, tokenAuthority, tokenOwnerAccountOneA, tokenVaultOneA, tokenOwnerAccountOneB, tokenVaultOneB, tokenOwnerAccountTwoA, tokenVaultTwoA, tokenOwnerAccountTwoB, tokenVaultTwoB, tickArrayOne0, tickArrayOne1, tickArrayOne2, tickArrayTwo0, tickArrayTwo1, tickArrayTwo2, oracleOne, oracleTwo, discountToken, whirlpoolDiscountInfoOne, whirlpoolDiscountInfoTwo, discountTokenOwnerAccount, } = params;
    const ix = program.instruction.twoHopSwapWithFeeDiscount(amount, otherAmountThreshold, amountSpecifiedIsInput, aToBOne, aToBTwo, sqrtPriceLimitOne, sqrtPriceLimitTwo, {
        accounts: {
            tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            tokenAuthority,
            whirlpoolOne,
            whirlpoolTwo,
            tokenOwnerAccountOneA,
            tokenVaultOneA,
            tokenOwnerAccountOneB,
            tokenVaultOneB,
            tokenOwnerAccountTwoA,
            tokenVaultTwoA,
            tokenOwnerAccountTwoB,
            tokenVaultTwoB,
            tickArrayOne0,
            tickArrayOne1,
            tickArrayOne2,
            tickArrayTwo0,
            tickArrayTwo1,
            tickArrayTwo2,
            oracleOne,
            oracleTwo,
            discountToken,
            whirlpoolDiscountInfoOne,
            whirlpoolDiscountInfoTwo,
            discountTokenOwnerAccount,
        },
    });
    return {
        instructions: [ix],
        cleanupInstructions: [],
        signers: [],
    };
}
exports.twoHopSwapWithFeeDiscountIx = twoHopSwapWithFeeDiscountIx;
